import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";


export default function OTPField({ handleSubmit, handleChange, formValues, errors, Logo, loading }) {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleOTPChange = (e, index) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return; // Only allow numbers

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    handleChange({ target: { name: "otp", value: newOtp.join("") } }); // Update form state

    // Move to the next input if a value is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && index > 0 && !otp[index]) {
      inputRefs.current[index - 1].focus();
    }
  };

  return (
    <form className="card-body cardbody-color p-lg-5 bg-glass" onSubmit={handleSubmit}>
      <div className="text-center">
        <img
          src={Logo}
          className="img-fluid profile-image-pic img-thumbnail rounded-circle mb-5"
          width="200px"
          alt="profile"
        />
      </div>

      {/* OTP Input Fields */}
      <div className="d-flex justify-content-center gap-2">
        {otp.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            className={`form-control text-center ${errors.otp ? "border border-danger" : ""}`}
            style={{ width: "40px", height: "50px", fontSize: "20px" }}
            maxLength="1"
            value={digit}
            onChange={(e) => handleOTPChange(e, index)}
            onKeyDown={(e) => handleBackspace(e, index)}
          />
        ))}
      </div>

      {/* Show error message if any */}
      {errors.otp && <span style={{ color: "red" }} className="d-block text-center mt-2">{errors.otp}</span>}

      {/* Submit Button */}
      <div className="text-center">
        <button type="submit" className="btn btn-color px-5 mt-3 mb-1 w-100" disabled={loading}>
          {loading ? "Loading..." : "Verify OTP"}
        </button>


      </div>

      <Link className="forgot-pass-text" to="/login" >Back to Login</Link>

    </form>
  );
}
